import { DEFAULT_PAGE_DIMENSIONS } from '@/app/crunches/[id]/constants'
import {
  Change,
  CitationOverlayItem,
  Source,
  VCCardProps,
  Version,
} from '@/dc-shared-web/src/hooks/api/comparison/types'
import { Instance } from '@nutrient-sdk/viewer'

export const getOverlayPosition = (
  source: Source,
  pageWidth: number,
  pageHeight: number
) => {
  const firstLine = source.lines[0]
  if (!firstLine) return { x: 0, y: 0 }

  return {
    x: pageWidth - 25,
    y: firstLine.bounds.top * pageHeight,
  }
}

export const fixOverlappingOverlays = (data: CitationOverlayItem[]) => {
  const sortedData = data.sort((a, b) =>
    a.pageIndex === b.pageIndex
      ? a.position.y - b.position.y
      : a.pageIndex - b.pageIndex
  )

  for (let i = 0; i < sortedData.length; i++) {
    if (i === 0) {
      continue
    }

    const previous = sortedData[i - 1]
    const current = sortedData[i]

    if (previous.pageIndex !== current.pageIndex) {
      continue
    }

    if (previous.position.y + 28 > current.position.y) {
      current.position.y = previous.position.y + 28
    }
  }

  return sortedData
}

export const sourceToOverlayItem = (
  change: Change,
  source: Source,
  instance: Instance,
  changeIndex: number
): CitationOverlayItem => {
  const firstLine = source.lines[0]
  if (!firstLine) {
    throw new Error('Source must have at least one line')
  }

  const id = `${change.uuid}-${source.id}`

  // Use the first page for positioning the tooltip marker
  const firstPageIndex = firstLine.page
  const page_info =
    instance.pageInfoForIndex(firstPageIndex) ?? DEFAULT_PAGE_DIMENSIONS

  return {
    id: id,
    baseId: id, // Base ID for grouping related overlays
    pageIndex: firstPageIndex, // Page where the tooltip marker will appear
    position: getOverlayPosition(source, page_info.width, page_info.height),
    type: change.change_type,
    source: source, // Full source with all lines across all pages
    version: firstLine.version ?? Version.A,
    changeIndex, // Index of the change in the full list for navigation purposes
  }
}

export const isVersionTwoTabSelected = ({
  comparisonList,
  comparisonUuid,
  versionUuid,
}: {
  comparisonList?: VCCardProps[]
  comparisonUuid?: string | null
  versionUuid?: string | null
}) => {
  if (!comparisonList || !comparisonUuid || !versionUuid) {
    return false
  }

  const comparison = comparisonList.find(
    (comparison) => comparison.uuid === comparisonUuid
  )

  if (!comparison) {
    return false
  }

  return comparison.version_b_guid === versionUuid
}
